import { Injectable } from '@angular/core';

/**
 * Configuration service for the FishTabset component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the tabsets used in the application.
 */

export class FishTabsetConfig {
  justify: 'start' | 'center' | 'end' = 'start';
  type: 'tabs' | 'pills' = 'tabs';
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
